import { Button, fmt, Icon } from "@nabble/ui";
import { useState } from "react";
import { NewRecoveryCodesDialog } from "./NewRecoveryCodesDialog";
import { RegenerateCodesDialog } from "./RegenerateCodesDialog";

/** At or below this many unused codes, the row warns that it's time to generate new ones. */
const LOW_RECOVERY_CODES = 3;

/** Second factor → Recovery codes: how many are left, and generating a new set. */
export function RecoveryCodesRow({ remaining, onChanged }: { remaining: number; onChanged: () => void }): React.JSX.Element {
  const [regenerateOpen, setRegenerateOpen] = useState(false);
  const [codes, setCodes] = useState<string[] | null>(null);
  const low = remaining <= LOW_RECOVERY_CODES;

  return (
    <>
      <div className="nb-setting-row">
        <div>
          <div className="nb-setting-title">Recovery codes</div>
          <p className="nb-setting-desc">They let you sign in if you lose your device. Each code can be used only once.</p>
        </div>
        <div className="nb-setting-content">
          <div className="nb-row-between">
            <span className={`nb-status-line ${low ? "" : "is-ok"}`}>
              <Icon name={low ? "alert" : "checkCircle"} style={low ? { color: "var(--warning-ink)" } : undefined} />
              {`You have ${fmt.number(remaining)} unused ${remaining === 1 ? "code" : "codes"} left`}
            </span>
            <Button label="Generate new ones" variant="secondary" size="sm" icon="refresh" onClick={() => setRegenerateOpen(true)} />
          </div>
        </div>
      </div>

      <RegenerateCodesDialog
        open={regenerateOpen}
        onClose={() => setRegenerateOpen(false)}
        onGenerated={(fresh) => {
          setRegenerateOpen(false);
          setCodes(fresh);
          onChanged();
        }}
      />

      {codes ? <NewRecoveryCodesDialog codes={codes} onClose={() => setCodes(null)} /> : null}
    </>
  );
}
